<div
  class="radio"
  [class.rv-card]="card"
  [class.card]="card"
  [class.disabled]="disabled"
  [class.inline]="inline"
  [class.bare]="labelRef.childNodes.length == 0"
  (click)="!disabled && changed.emit(true)"
>
  <div
    class="input-container"
    [class.checked]="selected"
    [class.unchecked]="!selected"
  >
    <input
      type="radio"
      #radioElement
      [id]="identifier"
      [disabled]="disabled"
      [checked]="selected"
      (click)="$event.stopPropagation()"
      (change)="changed.emit($event.target.checked)"
    />
  </div>
  <div class="label">
    <label #labelRef [for]="identifier">
      <ng-content></ng-content>
    </label>
  </div>
</div>
